import { Control, Controller, FieldErrors, UseFormGetValues, useWatch, } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { DatePicker } from '@mui/x-date-pickers';
import { FormsErrors } from "../../../hooks/Forms/FormsErrors"
import { Dispatch, SetStateAction, useEffect, useState } from "react"
import { AlertColor, Autocomplete, Box, Button, Switch, TextField, Typography } from "@mui/material"
import EditIcon from '@mui/icons-material/Edit';
import { useFormatNumber } from "../../../hooks/useFormatNumber";
import { ButtonLoading, myStylePickers } from "../../../theme/buttons";
import { PurchaseInvoice } from "../../../interfaces/Purchases/Invoices/purchaseInvoices"
import { SupplierLocation } from "../../../interfaces/Purchases/Catalogs/suppliers"
import dayjs from "dayjs";
import { useDates } from "../../../hooks/useDates";
import { SupplierBankAccount } from "../../../interfaces/Purchases/Catalogs/supplierBankAccounts";
import { BankAccount } from "../../../interfaces/Commons/bankAccounts";
import SaveIcon from '@mui/icons-material/Save';
import { Menuitem } from "../../../interfaces/Security/menu";
import { useParamsFilter } from "../../../hooks/useParamsFilter";
import { useLocation } from "react-router-dom";
import GenericPromises from "../../../api/GenericPromises";
import { Spinner } from "../../../components/Commons/Spinner/Spinner";

type InvoiceHeaderProps = {
  control: Control<PurchaseInvoice>,
  errors: FieldErrors<PurchaseInvoice>,
  purchaseInvoiceLocal: PurchaseInvoice | undefined,
  comboSupplierLocations: SupplierLocation[],
  defaultSupplierLocation: SupplierLocation | undefined,
  defaultSupplierBankAccount: SupplierBankAccount | undefined,
  comboSupplierBankAccounts: SupplierBankAccount[],
  setComboSupplierBankAccounts: Dispatch<SetStateAction<SupplierBankAccount[]>>
  getValues: UseFormGetValues<PurchaseInvoice>,
  locationEdit: boolean,
  setLocationEdit: Dispatch<SetStateAction<boolean>>,
  isEdit?: boolean,
  isNotExchange?: boolean,
  setIsNotExchange: Dispatch<SetStateAction<boolean>>,
  loading: boolean,
  disableKeyboardEntry: (e: any) => void,
  defaultDate: Date,
  defaultDateSupplier: Date | undefined,
  GetExchangeRateFromDates: (currency_id: number, datePurchaseInvoice: Date | undefined, dateSupplierInvoice: Date | undefined) => Promise<void>,
  comboBankAccountsGeneral: BankAccount[],
  defaultBankAccountFinal: BankAccount | undefined,
  setComboBankAccountsGeneral: Dispatch<SetStateAction<BankAccount[]>>,
  resourceScreen: Menuitem | undefined,
  showSnackBar: (message: string, severity: AlertColor) => void,
  onPut: (data: PurchaseInvoice) => Promise<void>,
  setHasFinalPaymentBankAccount: Dispatch<SetStateAction<boolean>>,
  isChangingSupplier: boolean,
}

export const UpdatePurchaseInvoicesHeader = ({
  control,
  errors,
  purchaseInvoiceLocal,
  defaultSupplierBankAccount,
  comboSupplierBankAccounts,
  setComboSupplierBankAccounts,
  defaultSupplierLocation,
  comboSupplierLocations,
  getValues,
  locationEdit,
  setLocationEdit,
  isEdit,
  isNotExchange,
  setIsNotExchange,
  GetExchangeRateFromDates,
  loading,
  disableKeyboardEntry,
  defaultDate,
  defaultDateSupplier,
  comboBankAccountsGeneral,
  defaultBankAccountFinal,
  setComboBankAccountsGeneral,
  resourceScreen,
  showSnackBar,
  onPut,
  setHasFinalPaymentBankAccount,
  isChangingSupplier,
}: InvoiceHeaderProps) => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const { setFormatNumber } = useFormatNumber();
  const { GetError } = FormsErrors();
  const { TimeConverter } = useDates();
  const { GetParamsFromBase64 } = useParamsFilter();
  const { GenericGetResource } = GenericPromises();
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [openDatePicker2, setOpenDatePicker2] = useState(false);
  const [isLoadingUpdateBankAccount, setIsLoadingUpdateBankAccount] = useState(false);
  const [saveNewSupplierBankAccount, setSaveNewSupplierBankAccount] = useState(false);
  const [saveNewGeneralBankAccount, setSaveNewGeneralBankAccount] = useState(false);
  const [supplierBankAccount, setSupplierBankAccount] = useState<SupplierBankAccount | undefined>(defaultSupplierBankAccount);
  const [finalBankAccount, setFinalBankAccount] = useState<BankAccount>();
  const totalAmount = useWatch({ control, name: "total_amount" });
  const subtotalAmount = useWatch({ control, name: "subtotal_amount" });
  const discountAmount = useWatch({ control, name: "discount_amount" });
  const taxAmount = useWatch({ control, name: "tax_amount" });
  const retentionAmount = useWatch({ control, name: "retention_amount" });
  const isAccounted = useWatch({ control, name: "is_accounted" });

  const supplierBusinessName = useWatch({ control, name: "supplier_business_name" });
  const supplierRfc = useWatch({ control, name: "supplier_rfc" });
  const supplierStreetName = useWatch({ control, name: "supplier_street_name" });
  const supplierCityName = useWatch({ control, name: "supplier_city_name" });
  const supplierStateName = useWatch({ control, name: "supplier_state_name" });
  const supplierCountryName = useWatch({ control, name: "supplier_country_name" });
  const currencyCode = useWatch({ control, name: "currency_code" });
  const supplierBankReferences = useWatch({ control, name: "supplier_bank_references" });

  const editLocation = () => {
    (locationEdit == true) ? setLocationEdit(false) : setLocationEdit(true);
  }

  const GetLocalParamsValues = () => {
    let purchaseInvoiceId;
    let supplierId;
    if (location.search.length > 0 && location.state === null) {
      const myParams = GetParamsFromBase64();
      purchaseInvoiceId = myParams.get("purchase_invoice_id");
      supplierId = myParams.get("supplier_id");
    }
    return { purchaseInvoiceId, supplierId };
  }

  const onLoadSupplierBankAccounts = async () => {
    if (resourceScreen?.update) {
      setIsLoadingUpdateBankAccount(true);
      if (comboSupplierBankAccounts.length < 1) {
        const { supplierId } = GetLocalParamsValues();
        GenericGetResource(`/supplierbankaccounts/bysupplierid/${(location.state && location.state.row.supplier_id) ?? (purchaseInvoiceLocal?.supplier_id ?? (supplierId) ?? 0)}`)
          .then((responseSupplierBankAccounts) => {
            const mySupplierBankAccounts: SupplierBankAccount[] = responseSupplierBankAccounts.data.data;
            setComboSupplierBankAccounts(mySupplierBankAccounts);
            setSaveNewSupplierBankAccount(true);
          })
          .catch((error) => showSnackBar(error.message, 'error'))
          .finally(() => setIsLoadingUpdateBankAccount(false));
      }
      else {
        setIsLoadingUpdateBankAccount(false);
        setSaveNewSupplierBankAccount(true);
      }
    }
    else {
      showSnackBar(t("purchaseinvoices.info.unauthorized"), "error")
    }
  }

  const onLoadGeneralBankAccounts = async () => {
    if (resourceScreen?.update) {
      setIsLoadingUpdateBankAccount(true);
      if (comboBankAccountsGeneral.length < 1) {
        GenericGetResource("/bankaccounts")
          .then((responseGeneralBankAccounts) => {
            const myGeneralBankAccounts: BankAccount[] = responseGeneralBankAccounts.data.data;
            setComboBankAccountsGeneral(myGeneralBankAccounts);
            setSaveNewGeneralBankAccount(true);
          })
          .catch((error) => showSnackBar(error.message, 'error'))
          .finally(() => setIsLoadingUpdateBankAccount(false));
      }
      else {
        setIsLoadingUpdateBankAccount(false);
        setSaveNewGeneralBankAccount(true);
      }
    }
    else {
      showSnackBar(t("purchaseinvoices.info.unauthorized"), "error")
    }
  }

  const onSaveNewSupplierBankAccount = async () => {
    setIsLoadingUpdateBankAccount(true);
    onPut(getValues())
      .then(() => {
        setSaveNewSupplierBankAccount(false);
        setIsLoadingUpdateBankAccount(false);
      })
      .catch(() => setIsLoadingUpdateBankAccount(false));
  }

  const onSaveNewGeneralBankAccount = async () => {
    setIsLoadingUpdateBankAccount(true);
    onPut(getValues())
      .then(() => {
        setSaveNewGeneralBankAccount(false);
        setIsLoadingUpdateBankAccount(false);
      })
      .catch(() => setIsLoadingUpdateBankAccount(false));
  }

  useEffect(() => {
    setIsNotExchange(false);
  }, [locationEdit, defaultSupplierLocation, isNotExchange]);

  useEffect(() => {
    setSupplierBankAccount(defaultSupplierBankAccount);
    setFinalBankAccount(defaultBankAccountFinal);
  }, []);

  useEffect(() => {
    setSupplierBankAccount(defaultSupplierBankAccount);
  }, [defaultSupplierBankAccount]);

  return (
    <>
      {isChangingSupplier && <Spinner isBox={false} />}
      {!isChangingSupplier &&
        <>
          <div className='d-flex'>
            {/* Left Box */}
            <div className={`d-flex ${isAccounted ? "w-25" : "w-50"}`}>
              <Box className='custom-card-view w-100' sx={{ marginRight: 2 }}>
                <div>
                  <Typography>{supplierBusinessName}</Typography>
                  <Typography>{supplierRfc}</Typography>
                  <Typography>{supplierStreetName} {supplierCityName ? "," : ""} {supplierCityName} {supplierStateName ? "," : ""} {supplierStateName}{supplierCountryName ? "," : ""} {supplierCountryName}<Button size="small" sx={{ flex: 1 }} onClick={editLocation}><EditIcon /></Button></Typography>
                </div>
                <div className="d-flex">
                  {locationEdit &&
                    <Controller
                      name="supplier_location_id"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Autocomplete
                          ref={field.ref}
                          size="small"
                          sx={{ maxWidth: "100%", minWidth: "80%" }}
                          options={comboSupplierLocations}
                          defaultValue={defaultSupplierLocation}
                          getOptionLabel={(option) => `${option.business_name}, ${option.supplier_rfc} - ${option.street}, ${option.city_name}, ${option.state_name}, ${option.country_name}`}
                          renderOption={(props, option: SupplierLocation) => (
                            <div key={option.supplier_location_id}>
                              <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                {option.business_name} - {option.street}, {option.city_name}, {option.state_name}, {option.country_name}
                              </Box>
                            </div>
                          )}
                          isOptionEqualToValue={(option, value) => option.supplier_location_id === value.supplier_location_id}
                          onChange={(_, values) => {
                            field.onChange(values?.supplier_location_id || null)
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={`${t("purchaseinvoices.fields.address")}`}
                              variant="filled"
                              value={field.value}
                              error={!!errors.supplier_location_id}
                              helperText={GetError(errors.supplier_location_id?.type)}
                            />
                          )}
                          disabled={isEdit}
                        />
                      )}
                    />
                  }
                </div>
              </Box>
              {!isAccounted &&
                <Box className='custom-card-view w-100' sx={{ marginRight: 2 }}>
                  <div>
                    <Typography>{purchaseInvoiceLocal?.company_business_name}</Typography>
                    <Typography>{purchaseInvoiceLocal?.company_rfc}</Typography>
                    <Typography>{purchaseInvoiceLocal?.company_phone_number}</Typography>
                    <Typography>{purchaseInvoiceLocal?.company_street}, {purchaseInvoiceLocal?.company_city_name}, {purchaseInvoiceLocal?.company_state_name}, {purchaseInvoiceLocal?.company_country_name}</Typography>
                  </div>
                </Box>
              }
            </div>
            {/* Right Box bank accounts */}
            <Box width={"100%"} className='custom-card-view d-flex flex-column'>
              <Box className="d-flex flex-row" sx={{ width: "100%" }}>
                {!isNotExchange &&
                  <Box sx={{ width: "50%" }} className="d-flex custom-card-view">
                    <Box className="w-100 d-flex flex-column">
                      <Typography fontWeight={"bold"} fontSize={15} marginRight={1}>
                        {t("purchaseinvoices.fields.account_deposit")}:
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.account_alias")}:
                          </Typography>
                          {supplierBankAccount?.account_alias}
                        </Typography>
                        {/* <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                  <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                    {t("purchaseinvoices.fields.bank_references")}:
                  </Typography>
                  {supplierBankAccount?.bank_references}
                </Typography> */}
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} width={"50%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.bank_name")}:
                          </Typography>
                          {supplierBankAccount?.bank_name}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("currencies.title-view")}:
                          </Typography>
                          {(supplierBankAccount?.currency_description) ? supplierBankAccount?.currency_description + "-" + supplierBankAccount?.currency_code : ""}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} width={"50%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.card_number")}:
                          </Typography>
                          {supplierBankAccount?.card_number}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.account_number")}:
                          </Typography>
                          {supplierBankAccount?.account_number}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} width={"55%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.interbank_key")}:
                          </Typography>
                          {supplierBankAccount?.interbank_key}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.swift_code")}:
                          </Typography>
                          {supplierBankAccount?.swift_code}
                        </Typography>
                      </Box>
                      <Box display={"flex"}>
                        <Controller
                          name="supplier_bank_account_id"
                          control={control}
                          rules={{ required: true }}
                          render={({ field }) =>
                            <Autocomplete
                              ref={field.ref}
                              size="small"
                              options={comboSupplierBankAccounts}
                              defaultValue={defaultSupplierBankAccount}
                              getOptionLabel={(option) => `${option.account_alias} - ${option.bank_name}${option.currency_code ? ` - ${option.currency_code}` : ``}`}
                              renderOption={(props, option: SupplierBankAccount) => (
                                <div key={option.supplier_bank_account_id}>
                                  <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                    {option.account_alias} - {option.bank_name} {(option.currency_code ? ` - ${option.currency_code}` : '')}
                                  </Box>
                                </div>
                              )}
                              sx={{ width: `${isAccounted ? "90%" : "100%"}` }}
                              isOptionEqualToValue={(option, value) => option.supplier_bank_account_id === value.supplier_bank_account_id}
                              onChange={async (_, values) => {
                                field.onChange(values?.supplier_bank_account_id || null);
                                await setSupplierBankAccount(values ?? undefined);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={`${t("payments.fields.supplierbankaccount")}`}
                                  variant="filled"
                                  value={field.value}
                                  size="small"
                                  error={!!errors.supplier_bank_account_id}
                                  helperText={GetError(errors.supplier_bank_account_id?.type)}
                                />
                              )}
                              disabled={isAccounted ? !saveNewSupplierBankAccount : isEdit}
                            />
                          }
                        />
                        {isAccounted &&
                          <ButtonLoading
                            isLoading={isLoadingUpdateBankAccount}
                            color="primary"
                            sx={{ marginInline: 1, width: '5%' }}
                            onClick={() => {
                              if (saveNewSupplierBankAccount) {
                                onSaveNewSupplierBankAccount();
                              }
                              else {
                                onLoadSupplierBankAccounts();
                              }
                            }}
                          >
                            {saveNewSupplierBankAccount ? <SaveIcon /> : <EditIcon />}
                          </ButtonLoading>
                        }
                      </Box>
                    </Box>
                  </Box>
                }
                {!isNotExchange &&
                  <Box sx={{ width: "50%", marginLeft: 2 }} className="d-flex custom-card-view">
                    <Box className="w-100 d-flex flex-column">
                      <Typography fontWeight={"bold"} fontSize={15} marginRight={1}>
                        {t("purchaseinvoices.fields.account_pay")}:
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.account_alias")}:
                          </Typography>
                          {finalBankAccount?.account_alias}
                        </Typography>
                        {/* <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                  <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                    {t("purchaseinvoices.fields.bank_references")}:
                  </Typography>
                  {finalBankAccount?.bank_references}
                </Typography> */}
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} width={"50%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.bank_name")}:
                          </Typography>
                          {finalBankAccount?.bank_name}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("currencies.title-view")}:
                          </Typography>
                          {(finalBankAccount?.currency_description) ? finalBankAccount?.currency_description + "-" + finalBankAccount?.currency_code : ""}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} width={"50%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.card_number")}:
                          </Typography>
                          {finalBankAccount?.card_number}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.account_number")}:
                          </Typography>
                          {finalBankAccount?.account_number}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} width={"55%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.interbank_key")}:
                          </Typography>
                          {finalBankAccount?.interbank_key}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1} component={"span"}>
                            {t("purchaseinvoices.fields.swift_code")}:
                          </Typography>
                          {finalBankAccount?.swift_code}
                        </Typography>
                      </Box>
                      <Box display={"flex"}>
                        <Controller
                          name="intermediary_bank_account_id"
                          control={control}
                          rules={{}}
                          render={({ field }) =>
                            <Autocomplete
                              ref={field.ref}
                              size="small"
                              options={comboBankAccountsGeneral}
                              defaultValue={defaultBankAccountFinal}
                              getOptionLabel={(option) => `${option.account_alias} - ${option.bank_name}${option.currency_code ? ` - ${option.currency_code}` : ``}`}
                              renderOption={(props, option: BankAccount) => (
                                <div key={option.bank_account_id}>
                                  <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                    {option.account_alias} - {option.bank_name} {(option.currency_code ? ` - ${option.currency_code}` : '')}
                                  </Box>
                                </div>
                              )}
                              sx={{ width: "100%" }}
                              isOptionEqualToValue={(option, value) => option.bank_account_id === value.bank_account_id}
                              onChange={async (_, values) => {
                                field.onChange(values?.bank_account_id || null);
                                await setFinalBankAccount(values ?? undefined);
                                if (!values?.bank_account_id) {
                                  setHasFinalPaymentBankAccount(false);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={`${t("payments.fields.finalbankaccount")}`}
                                  variant="filled"
                                  value={field.value}
                                  size="small"
                                  error={!!errors.intermediary_bank_account_id}
                                  helperText={GetError(errors.intermediary_bank_account_id?.type)}
                                />
                              )}
                              disabled={isAccounted ? !saveNewGeneralBankAccount : isEdit}
                            />
                          }
                        />
                        {isAccounted &&
                          <ButtonLoading
                            isLoading={isLoadingUpdateBankAccount}
                            color="primary"
                            sx={{ marginInline: 1, width: '5%' }}
                            onClick={() => {
                              if (saveNewGeneralBankAccount) {
                                onSaveNewGeneralBankAccount();
                              }
                              else {
                                onLoadGeneralBankAccounts();
                              }
                            }}
                          >
                            {saveNewGeneralBankAccount ? <SaveIcon /> : <EditIcon />}
                          </ButtonLoading>
                        }
                      </Box>
                    </Box>
                  </Box>
                }
              </Box>
              {isAccounted ?
                <Typography width={"100%"} marginTop={1}>{t("purchaseinvoices.fields.bank_references")}: {supplierBankReferences}</Typography>
                :
                <Controller
                  name="supplier_bank_references"
                  control={control}
                  rules={{ maxLength: 500 }}
                  render={({ field }) => (
                    <TextField
                      variant="filled"
                      label={`${t("purchaseinvoices.fields.bank_references")}`}
                      ref={field.ref}
                      value={field.value}
                      onChange={(event) => { field.onChange(event.target.value) }}
                      size="small"
                      sx={{ width: "100%", marginBottom: 1, marginTop: 1 }}
                      error={!!errors.supplier_bank_references}
                      helperText={GetError(errors.supplier_bank_references?.type)}
                      disabled={isAccounted ? !saveNewSupplierBankAccount : isEdit}
                    />
                  )}
                />
              }
            </Box>
          </div>
          <div className="d-flex w-100">
            <div className="w-50"></div>
            <div className='d-flex flex-column w-50'>
              {/* first Row */}
              <div className='d-flex mt-2'>
                <Box sx={{ flex: 9 }}>
                  {!isNotExchange &&
                    <Controller
                      name="purchase_invoice_date"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) =>
                        <DatePicker
                          open={openDatePicker}
                          onClose={() => setOpenDatePicker(false)}
                          ref={field.ref}
                          label={`${t("purchaseinvoices.fields.purchase_invoice_date")}`}
                          onChange={(day, _) => {
                            field.onChange(day)
                            GetExchangeRateFromDates(getValues("currency_id") ?? 0, day?.toDate(), getValues("supplier_sale_invoice_date"))
                          }}
                          slotProps={{
                            popper: {
                              sx: myStylePickers
                            },
                            textField: {
                              variant: "filled",
                              size: "small",
                              fullWidth: true,
                              onClick: () => setOpenDatePicker(true),
                              onBeforeInput: disableKeyboardEntry,
                              sx: { paddingRight: 2 },
                              error: !!errors.purchase_invoice_date,
                              helperText: GetError(errors.purchase_invoice_date?.type),
                            }
                          }}
                          defaultValue={dayjs(TimeConverter(defaultDate.toString())) ?? dayjs()}
                          format="DD/MM/YYYY"
                          disableFuture
                          disabled={isEdit}
                        />
                      }
                    />
                  }
                </Box>
                <Box sx={{ flex: 9 }}>
                  {!isNotExchange &&
                    <Controller
                      name="supplier_sale_invoice_date"
                      control={control}
                      rules={{}}
                      render={({ field }) =>
                        <DatePicker
                          open={openDatePicker2}
                          onClose={() => setOpenDatePicker2(false)}
                          ref={field.ref}
                          label={`${t("purchaseinvoices.fields.supplier_sale_invoice_date")}`}
                          onChange={(day, _) => {
                            field.onChange(day)
                            GetExchangeRateFromDates(getValues("currency_id") ?? 0, getValues("purchase_invoice_date"), day?.toDate());
                          }}
                          slotProps={{
                            popper: {
                              sx: myStylePickers
                            },
                            textField: {
                              variant: "filled",
                              size: "small",
                              fullWidth: true,
                              onClick: () => setOpenDatePicker2(true),
                              onBeforeInput: disableKeyboardEntry,
                              error: !!errors.supplier_sale_invoice_date,
                              helperText: GetError(errors.supplier_sale_invoice_date?.type),
                            }
                          }}
                          defaultValue={defaultDateSupplier ? dayjs(defaultDateSupplier.toString()) : undefined}
                          format="DD/MM/YYYY"
                          disableFuture
                          disabled={isEdit}
                        />
                      }
                    />
                  }
                </Box>
                <Box sx={{ flex: 11 }} className="d-flex flex-column mx-2" >
                  <Typography noWrap alignSelf={'end'} fontWeight={'Bold'} fontSize={15}>{t("purchaseinvoices.fields.tax_amount")}: {setFormatNumber({ value: taxAmount ?? 0 })} {currencyCode}</Typography>
                  <Typography noWrap alignSelf={'end'} fontWeight={'Bold'} fontSize={15}>{t("purchaseinvoices.fields.retention_amount")}: {setFormatNumber({ value: retentionAmount ?? 0 })} {currencyCode}</Typography>
                </Box>
              </div>
              {/* second Row */}
              <div className='d-flex mt-2'>
                <Box sx={{ flex: 11 }} className='d-flex flex-column mx-2'>
                  <Typography noWrap alignSelf={'end'} fontWeight={'Bold'} fontSize={15}>{t("purchaseinvoices.fields.discount_amount")}:{setFormatNumber({ value: discountAmount ?? 0 })} {currencyCode}</Typography>
                </Box>
              </div>
              {/* Fourth row */}
              <div className="d-flex mt-2">
                <Box sx={{ flex: 11 }} className='d-flex flex-column mx-2'>
                  <Typography noWrap alignSelf={'end'} fontWeight={'Bold'}>{t("purchaseinvoices.fields.subtotal_amount")}:  {setFormatNumber({ value: subtotalAmount ?? 0 })} {currencyCode}</Typography>
                  <Typography noWrap alignSelf={'end'} fontWeight={'Bold'}>{t("purchaseinvoices.fields.total_amount")}: {setFormatNumber({ value: totalAmount ?? 0 })} {currencyCode}</Typography>
                </Box>
              </div>
            </div>
          </div>
          <div className="d-flex flex-row-reverse mt-2">
            <div className="w-50">
              <ButtonLoading isLoading={loading} type="submit" size="small" className="d-flex align-self-end w-100" variant="outlined" disabled={isEdit}>{t("generic.buttons.save")}</ButtonLoading>
            </div>
            <div className="w-50"></div>
            <div className="w-25">
              <Controller
                name="is_accounted"
                control={control}
                render={({ field }) =>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", paddingRight: 2 }}>
                    <Typography>{t("purchaseinvoices.fields.is_accounted")}</Typography>
                    <Switch
                      ref={field.ref}
                      onChange={(_, e) => {
                        field.onChange(e);
                      }}
                      value={field.value}
                      disabled={true}
                      checked={field.value}
                      defaultChecked={purchaseInvoiceLocal?.is_accounted} />
                  </Box>
                }
              />
            </div>
          </div>
        </>
      }
    </>
  )
}
